module.exports = __webpack_public_path__ + "static/media/brush--pink.b43652f1.svg";